module.exports = __webpack_public_path__ + "tinymce-small.a2a1f732cc34764c684e.svg";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/tinymce/skins/lightgray/fonts/tinymce-small.svg
// module id = ../../../../../src/assets/tinymce/skins/lightgray/fonts/tinymce-small.svg
// module chunks = styles